import React, {useState} from "react";
import { Box, Button, Column, Columns, Control, Field, Input, TextArea, Title } from "@allxsmith/bestax-bulma";
import {useDispatch} from "react-redux";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import Nav from "../../Nav/Nav";



export default function PartEnquiryForm(props){

    const [description, setDescription] = useState("");
    const [registration, setRegistration] = useState();
    const [make, setMake] = useState();
    const [model, setModel] = useState();
    const dispatch = useDispatch();


    const validator = (enquiry) => {
        if(enquiry.description){
            return true
        }
        else{
            toast.warning("Description are required", {position: "top-right"})
            return false
        }
    }

    const onSave = () => {
        let enquiry = {
            description: description,
            registration: registration,
            make: make,
            model: model
        };
        if(validator(enquiry)){
            const conf = {
              method: "post",
              data: enquiry,
              url: "api/createpartenquiry"
            };
            axios(conf).then((res) => {
              if (res) {
               window.open("/editpartorder/" + res.data.id, "_self")
              }
            }).catch(err => {
              if (err.response.data) {
                toast.error(
                  JSON.stringify(err.response.data), {position: "top-right"});
              }
            });
        }
    }

    return (
        <div>
            <Nav/>
            <Box>
                <Title>Part Enquiry</Title>
                <Columns isMultiline>
                    <Column>
                        <Field>
                            <label className="label">Enquiry Vehicle Registration</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    onInput={(e) => setRegistration(e.target.value)}
                                />
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Enquiry Vehicle Make</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    onInput={(e) => setMake(e.target.value)}
                                />
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Enquiry Vehicle Model</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    onInput={(e) => setModel(e.target.value)}
                                />
                            </Control>
                        </Field>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Field>
                            <label className="label">Description of Parts</label>
                            <TextArea
                                value={description}
                                onInput={(e) => setDescription(e.target.value)}
                            />
                        </Field>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            color={"success"}
                            onClick={onSave}
                            isFullWidth
                        >
                            Create Part Enquiry
                        </Button>
                    </Column>
                </Columns>
            </Box>
        </div>
    );



}